import React from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const formatRegioes = (regiaoRaw) => {
  const regioes = (regiaoRaw || "")
    .split("|")
    .map((item) => item.trim())
    .filter(Boolean);

  if (regioes.length === 0) return "-";
  if (regioes.length <= 2) return regioes.join(", ");
  return `${regioes[0]}, ${regioes[1]} +${regioes.length - 2}`;
};

const TabelaImobiliaria = ({ imobiliarias = [], loading = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 3,
        bgcolor: "background.paper",
        boxShadow: (theme) =>
          theme.palette.mode === "dark"
            ? "0 2px 12px rgba(0,0,0,0.28)"
            : "0 2px 12px rgba(0,0,0,0.08)",
        border: "1px solid",
        borderColor: "divider",
        overflowX: isMobile ? "auto" : "hidden",
      }}
      aria-label="Tabela com lista de imobiliarias"
    >
      <Table sx={{ minWidth: 600 }}>
        <TableHead>
          <TableRow
            sx={{
              background: (theme) =>
                theme.palette.mode === "dark"
                  ? "linear-gradient(135deg, rgba(102, 126, 234, 0.16) 0%, rgba(118, 75, 162, 0.18) 100%)"
                  : "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
              "& .MuiTableCell-head": {
                fontWeight: "bold",
                fontSize: "0.9rem",
                color: "text.primary",
                letterSpacing: "0.5px",
                py: 2,
                borderBottom: "2px solid",
                borderColor: "divider",
              },
            }}
          >
            <TableCell sx={{ width: "45%" }}>
              Nome
            </TableCell>
            <TableCell sx={{ width: "35%" }}>
              Região
            </TableCell>
            <TableCell sx={{ width: "20%" }}>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Chip
                  label={`${imobiliarias.length} ${imobiliarias.length === 1 ? "Imobiliária" : "Imobiliárias"}`}
                  onClick={() => {}}
                  clickable={false}
                  sx={{
                    bgcolor: "action.selected",
                    color: "text.primary",
                    fontWeight: "medium",
                    fontSize: "0.75rem",
                  }}
                />
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <Box sx={{ py: 5 }}>
                  <CircularProgress size={40} />
                  <Typography sx={{ mt: 2, color: "text.secondary" }}>
                    Carregando imobiliárias...
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : imobiliarias.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  Nenhuma imobiliaria encontrada.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            imobiliarias.map((imobiliaria, index) => (
              <TableRow
                key={`${imobiliaria.nome}-${index}`}
                sx={{
                  "&:nth-of-type(even)": {
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.03)"
                        : "rgba(0,0,0,0.02)",
                  },
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }}
              >
                <TableCell sx={{ width: "45%" }}>
                  <Typography variant="body2" color="text.primary">
                    {imobiliaria.nome || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ width: "35%" }}>
                  <Typography variant="body2" color="text.primary">
                    {formatRegioes(imobiliaria.regiao)}
                  </Typography>
                </TableCell>
                <TableCell sx={{ width: "20%" }}>
                  <Typography variant="body2" color="text.secondary">
                    
                  </Typography>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TabelaImobiliaria;
